import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getProDetail} from '../../../apis/user/getProDetail'

const useQueryProDetail = (id?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.user.getProDetail(id),
        queryFn: async () => {
            const {data} = await getProDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryProDetail
